import { WhatsappLogo } from "@phosphor-icons/react";
import { useSite, whatsappHref } from "@/context/SiteContext";

export function FloatingWhatsApp() {
  const content = useSite();
  if (content.whatsapp_enabled === false || !(content.whatsapp_number || "").trim()) return null;
  return (
    <a
      href={whatsappHref(content)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with CareDeserved on WhatsApp"
      data-testid="floating-whatsapp"
      className="group fixed bottom-5 left-5 z-40 flex items-center gap-2.5 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg shadow-black/20 ring-1 ring-black/5 transition-transform duration-200 hover:scale-105 hover:bg-[#1ebe5d] sm:bottom-6 sm:left-6"
    >
      <WhatsappLogo size={26} weight="fill" className="shrink-0" />
      <span className="hidden pr-1 text-sm font-semibold sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
